@switch (value) {
    @case ('pending') {
        <span  class="p-1 rounded text-white bg-warning" >
            En attente
        </span>
    }
    @case ('public') {
        <span  class="p-1 rounded text-white bg-primary" >
            Public
        </span>
    }
    @case ('suspended') {
        <span  class="p-1 rounded text-white bg-warning" >
            Suspendu
        </span>
    }
    @case ('hidden') {
        <span  class="p-1 rounded text-white bg-danger" >
            Caché
        </span>
    }
    @case ('payant') {
        <span  class="p-1 rounded text-white bg-warning" >
            Payant
        </span>
    }
    @case ('visible') {
        <span  class="p-1 rounded text-white bg-warning" >
            Visible
        </span>
    }
    @case ('picked') {
        <span  class="p-1 rounded text-white bg-warning" >
            En livraison
        </span>
    }
    @case ('started') {
        <span  class="p-1 rounded text-white bg-info" >
            Livreur affecté
        </span>
    }
    @case ('canceled') {
        <span  class="p-1 rounded text-white bg-danger" >
            Annulée
        </span>
    }
    @case ('cancelled') {
        <span  class="p-1 rounded text-white bg-danger" >
            Annulée
        </span>
    }
    @case ('confirmed') {
        <span  class="p-1 rounded text-white bg-info" >
            Confirmée
        </span>
    }
    @case ('deleted') {
        <span  class="p-1 rounded text-white bg-danger" >
            Cachée
        </span>
    }
    @case ('deleted') {
        <span  class="p-1 rounded text-white bg-danger" >
            Supprimé
        </span>
    }
    @case ('refused') {
        <span  class="p-1 rounded text-white bg-danger" >
            Refusée
        </span>
    }
    @case ('privé') {
        <span  class="p-1 rounded text-white bg-danger" >
            Privé
        </span>
    }
    @case ('completed') {
        <span  class="p-1 rounded text-white bg-success" >
            Validée
        </span>
    }
    @case ('paid') {
        <span  class="p-1 rounded text-white bg-success" >
            Payée
        </span>
    }
    @case ('accepted') {
        <span  class="p-1 rounded text-white bg-success" >
            Acceptée
        </span>
    }
    @case ('in_progress') {
        <span  class="p-1 rounded text-white bg-info" >
            En cours
        </span>
    }
    @case ('visible') {
        <span  class="p-1 rounded text-white bg-success" >
            Visible
        </span>
    }
    @case ('activated') {
        <span  class="p-1 rounded text-white bg-success" >
            Activé
        </span>
    }
    @default {
      <span >-----</span>
    }
  }
  